import { render, staticRenderFns } from "./HistoryOrderList.vue?vue&type=template&id=cf82a2bc&scoped=true&"
import script from "./HistoryOrderList.vue?vue&type=script&lang=js&"
export * from "./HistoryOrderList.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrderList.vue?vue&type=style&index=0&id=cf82a2bc&lang=scss&scoped=true&"
import style1 from "./HistoryOrderList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf82a2bc",
  null
  
)

export default component.exports